const EDIT_PRODUCT_DRAFT_PREFIX = 'admin:productDraft:edit:'
export const NEW_PRODUCT_DRAFT_KEY = 'admin:productDraft:new'
const PRODUCT_IMAGE_FILE_TYPES = ['image/png', 'image/jpg', 'image/jpeg']
export const PRODUCT_IMAGE_FILE_ACCEPT = 'image/png,image/jpg,image/jpeg'
export const PRODUCT_IMAGE_FILE_ERROR_MESSAGE = 'png, jpg, jpeg 형식의 이미지만 업로드할 수 있습니다.'

// 대회 이미지는 기존 운영 기준인 PNG/JPG/JPEG MIME type만 통과시킨다.
export const isProductImageFile = (file) => {
    return Boolean(file) && PRODUCT_IMAGE_FILE_TYPES.includes(file.type)
}

const PRODUCT_DRAFT_FIELDS = [
    'meetType',
    'meetType2',
    'title',
    'country',
    'area',
    'address',
    'addressDetail',
    'startTime',
    'endTime',
    'info1',
    'info2',
    'info3',
    'info4',
    'visibleStatus',
    'basicLike',
]

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeNumberValue = (value, fallbackValue = '') => {
    if (value === '' || value === null || value === undefined) {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

const serializeDateValue = (value) => {
    if (value === null) {
        return null
    }

    if (value === undefined || value === '') {
        return ''
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? '' : nextDate.toISOString()
}

const parseDateValue = (value, fallbackValue) => {
    if (value === null) {
        return null
    }

    if (value === undefined || value === '') {
        return fallbackValue
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? fallbackValue : nextDate
}

const normalizeOptionItem = (item = {}, index = 0) => {
    return {
        ...item,
        id: item.id ?? index,
        type: normalizeNumberValue(item.type, 0),
        distance: normalizeNumberValue(item.distance, 0),
        price: normalizeNumberValue(item.price, 0),
        quantity: normalizeNumberValue(item.quantity, 0),
        name: item.name || '',
        order: normalizeNumberValue(item.order, index),
    }
}

const canRestoreAddressModal = (draftData = {}, openModal) => {
    return Boolean(openModal && normalizeNumberValue(draftData.meetType, 1) === 1 && normalizeNumberValue(draftData.meetType2, 1) !== 3)
}

// 상세/등록 폼에서 실제로 수정 가능한 값만 sessionStorage에 남긴다.
export const createProductDraftPayload = ({ data = {}, arr = [], beginDay, finishDay, openModal = false }) => {
    return {
        data: {
            meetType: normalizeNumberValue(data.meetType, 1),
            meetType2: normalizeNumberValue(data.meetType2, 1),
            title: data.title || '',
            country: data.country || '',
            area: data.area || '',
            address: data.address || '',
            addressDetail: data.addressDetail || '',
            startTime: serializeDateValue(data.startTime),
            endTime: serializeDateValue(data.endTime),
            info1: data.info1 || '',
            info2: data.info2 || '',
            info3: data.info3 || '',
            info4: data.info4 || '',
            visibleStatus: normalizeNumberValue(data.visibleStatus, 0),
            basicLike: normalizeNumberValue(data.basicLike, 0),
        },
        arr: Array.isArray(arr) ? arr.map(normalizeOptionItem) : [],
        beginDay: serializeDateValue(beginDay),
        finishDay: serializeDateValue(finishDay),
        openModal: canRestoreAddressModal(data, openModal),
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 입력 흐름을 이어간다.
export const applyProductDraft = ({
    baseData = {},
    baseArr = [],
    beginDay,
    finishDay,
    draft,
}) => {
    if (!draft) {
        return {
            data: baseData,
            arr: baseArr,
            beginDay,
            finishDay,
            openModal: false,
        }
    }

    const draftData = draft.data || {}
    const nextData = {
        ...baseData,
    }

    PRODUCT_DRAFT_FIELDS.forEach((field) => {
        if (draftData[field] === undefined) {
            return
        }

        if (field === 'startTime' || field === 'endTime') {
            nextData[field] = parseDateValue(draftData[field], baseData[field] ?? null)
            return
        }

        nextData[field] = draftData[field]
    })

    return {
        data: nextData,
        arr: Array.isArray(draft.arr) ? draft.arr.map(normalizeOptionItem) : baseArr,
        beginDay: parseDateValue(draft.beginDay, beginDay),
        finishDay: parseDateValue(draft.finishDay, finishDay),
        openModal: canRestoreAddressModal(nextData, draft.openModal),
    }
}

export const createEditProductDraftKey = (productId) => `${EDIT_PRODUCT_DRAFT_PREFIX}${productId}`

export const readProductDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveProductDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 입력 흐름은 그대로 유지한다.
    }
}

export const clearProductDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
